export const PLC_OPTIONS = [
  { id: "corner", label: "Corner Plot", rate: 0.1 },
  { id: "green", label: "Green / Park Facing", rate: 0.07 },
  { id: "wideRoad", label: "Wide Road", rate: 0.1 },
];

export const RECEIPT_PLC_OPTIONS = [
  PLC_OPTIONS[0],
  PLC_OPTIONS[2],
  PLC_OPTIONS[1],
];

export const PLC_PENDING_LABEL =
  "PLC will be decided after final layout launch and after plot allocation";

export const PLOT_PENDING_LABEL =
  "To be declared after plot allocation on layout launch";

export const PLC_HALF_RATE_NOTE =
  "In case of 2 PLC, second will be charged half. In case of 3 PLC, next 2 will be charged half.";

export const LAYOUT_COMBINED_NOTE = {
  title: "NOTE:-",
  body: "If any Allottee is not willing to choose their preferred Plot Number, the Plot Allocation Amount shall become payable at the time of CLU approval, i.e., 25% of the Basic Sale Price plus 50% of the PLC (Preferential Location Charges).",
  footer: "Please note that if the Allottee does not select a Plot Number, the plot will be allotted based on the availability at that time, and no preference claim shall be entertained thereafter.",
};

export const PAYMENT_PLAN_STAGE_DEFS = [
  { id: "token", label: "Booking Amount on Application", isToken: true },
  {
    id: "plotAllocation",
    label: "On Plot Allocation",
    bspPercent: 0.125,
    plcPercent: 0,
    skipWhenCombinedLayout: true,
  },
  {
    id: "layout",
    label: "On CLU (Layout Approval)",
    bspPercent: 0.125,
    plcPercent: 0.5,
    combinedBspPercent: 0.25,
    combinedPlcPercent: 0.5,
  },
  { id: "rera", label: "On RERA Approval", bspPercent: 0.15, plcPercent: 0.5 },
  {
    id: "roadsSewerage",
    label: "On Start of Leveling of Roads & Sewerage",
    bspPercent: 0.1,
    plcPercent: 0,
  },
  {
    id: "electricity",
    label: "On Completion of Electricity Work",
    bspPercent: 0.15,
    plcPercent: 0.5,
  },
  { id: "possession", label: "On Offer of Possession", bspPercent: 0.1, plcPercent: 0 },
];

export const EMPTY_APPLICANT = {
  name: "",
  email: "",
  address: "",
  mobile: "",
  aadhaar: "",
  pan: "",
};

export function normalizeInventoryCount(value, inventoryType) {
  const n = Number(value);
  if (Number.isFinite(n) && n >= 1) return Math.floor(n);

  if (inventoryType) {
    const text = String(inventoryType).trim();
    const numericMatch = text.match(/^(\d+)\s+Residential\s+Plot/i);
    if (numericMatch) return Number(numericMatch[1]);
    if (/^one\s+residential\s+plot$/i.test(text)) return 1;
  }

  return 1;
}

export function formatInventoryType(count) {
  const plots = normalizeInventoryCount(count);
  return plots === 1 ? "1 Residential Plot" : `${plots} Residential Plots`;
}

export function formatTentativeSize(customer) {
  const size = customer?.sizeSqYds;
  if (size == null || size === "" || Number.isNaN(Number(size))) return null;

  const base = `${size} Sq. Yds`;
  const remarks = (customer.sizeRemarks || "").trim();
  return remarks ? `${base} (${remarks})` : base;
}

export const EMPTY_CUSTOMER_FORM = {
  name: "",
  userId: "",
  email: "",
  address: "",
  mobile: "",
  aadhaar: "",
  pan: "",
  jointDeal: false,
  applicant2: { ...EMPTY_APPLICANT },
  plotNumber: "",
  plotPending: false,
  inventoryCount: "1",
  category: "Residential",
  sizeSqYds: "",
  sizeRemarks: "",
  basicRatePerSqYd: "",
  noPlc: true,
  plcPending: false,
  plc: { corner: false, green: false, wideRoad: false },
  customPlc: { enabled: false, mode: "percent", percent: "", amount: "" },
  tokenAmount: "",
  layoutCombined: false,
  manualPricing: false,
  manualBsp: "",
  manualPlcAmount: "",
  manualStages: {},
};

export function calculateCustomPlcAmount(bsp, customPlc) {
  if (!customPlc?.enabled) return 0;
  if (customPlc.mode === "amount") {
    const amount = Number(customPlc.amount);
    return Number.isFinite(amount) && amount > 0 ? Math.round(amount) : 0;
  }
  const percent = Number(customPlc.percent);
  return Number.isFinite(percent) && percent > 0 ? Math.round((bsp * percent) / 100) : 0;
}

export function calculateStandardPlcAmount(bsp, plcFlags, noPlc) {
  if (noPlc) return 0;
  const selected = PLC_OPTIONS.filter((opt) => plcFlags[opt.id]).sort((a, b) => b.rate - a.rate);
  if (!selected.length || !bsp) return 0;

  let total = 0;
  selected.forEach((opt, index) => {
    const multiplier = index === 0 ? 1 : 0.5;
    total += bsp * opt.rate * multiplier;
  });
  return Math.round(total);
}

export function calculatePlcAmount(bsp, plcFlags, noPlc = false, plcPending = false, customPlc = null) {
  if (plcPending) return 0;
  const standard = calculateStandardPlcAmount(bsp, plcFlags, noPlc);
  const custom = calculateCustomPlcAmount(bsp, customPlc);
  return standard + custom;
}

export function calculateBsp(sizeSqYds, basicRatePerSqYd) {
  const size = Number(sizeSqYds);
  const rate = Number(basicRatePerSqYd);
  if (!size || !rate) return 0;
  return Math.round(size * rate);
}

export function resolveTokenAmount(bsp, tokenAmount) {
  const amount = Number(tokenAmount);
  if (Number.isFinite(amount) && amount > 0) return Math.round(amount);
  return Math.round(bsp * 0.25);
}

function getStagePercents(stageDef, layoutCombined) {
  if (stageDef.isToken) return { bspPercent: 0, plcPercent: 0 };
  if (stageDef.id === "layout" && layoutCombined) {
    return {
      bspPercent: stageDef.combinedBspPercent,
      plcPercent: stageDef.combinedPlcPercent ?? stageDef.plcPercent,
    };
  }
  return { bspPercent: stageDef.bspPercent, plcPercent: stageDef.plcPercent };
}

function shouldIncludeStage(stageDef, layoutCombined) {
  if (stageDef.isToken) return true;
  if (layoutCombined && stageDef.skipWhenCombinedLayout) return false;
  return true;
}

export function buildPaymentPlan(bsp, plcAmount, tokenAmount, layoutCombined = false) {
  const tokenBspAmount = resolveTokenAmount(bsp, tokenAmount);

  return PAYMENT_PLAN_STAGE_DEFS.filter((stageDef) => shouldIncludeStage(stageDef, layoutCombined)).map((stageDef) => {
    if (stageDef.isToken) {
      const bspPercent = bsp > 0 ? tokenBspAmount / bsp : 0;
      return {
        id: stageDef.id,
        label: stageDef.label,
        bspPercent,
        plcPercent: 0,
        bspAmount: tokenBspAmount,
        plcAmount: 0,
        totalAmount: tokenBspAmount,
        isToken: true,
      };
    }

    const { bspPercent, plcPercent } = getStagePercents(stageDef, layoutCombined);
    const bspAmount = Math.round(bsp * bspPercent);
    const plcStageAmount = Math.round(plcAmount * plcPercent);

    return {
      id: stageDef.id,
      label: stageDef.label,
      bspPercent,
      plcPercent,
      bspAmount,
      plcAmount: plcStageAmount,
      totalAmount: bspAmount + plcStageAmount,
      isToken: false,
    };
  });
}

export function parseManualAmount(value) {
  const amount = Number(value);
  return Number.isFinite(amount) && amount >= 0 ? Math.round(amount) : 0;
}

export function manualStagesFromPaymentPlan(paymentPlan = []) {
  const stages = {};
  for (const stage of paymentPlan) {
    stages[stage.id] = {
      bspAmount: stage.bspAmount != null && stage.bspAmount !== 0 ? String(stage.bspAmount) : "",
      plcAmount: stage.plcAmount != null && stage.plcAmount !== 0 ? String(stage.plcAmount) : "",
    };
  }
  return stages;
}

export function buildManualPricingSeed(bsp, plcAmount, paymentPlan = []) {
  return {
    manualBsp: bsp ? String(bsp) : "",
    manualPlcAmount: plcAmount ? String(plcAmount) : "",
    manualStages: manualStagesFromPaymentPlan(paymentPlan),
  };
}

export function reconcileManualStages(manualStages, layoutCombined, fallbackPlan = []) {
  const stages = { ...manualStages };

  if (layoutCombined) {
    delete stages.plotAllocation;
  } else if (!stages.plotAllocation) {
    stages.plotAllocation = { bspAmount: "", plcAmount: "" };
  }

  for (const stage of fallbackPlan) {
    if (!stages[stage.id]) {
      stages[stage.id] = {
        bspAmount: stage.bspAmount ? String(stage.bspAmount) : "",
        plcAmount: stage.plcAmount ? String(stage.plcAmount) : "",
      };
    }
  }

  return stages;
}

export function buildPaymentPlanFromManual({
  manualBsp,
  manualPlcAmount,
  manualStages = {},
  tokenAmount,
  layoutCombined = false,
  plcPending = false,
}) {
  const bsp = parseManualAmount(manualBsp);
  const plcTotal = plcPending ? 0 : parseManualAmount(manualPlcAmount);

  return PAYMENT_PLAN_STAGE_DEFS.filter((stageDef) => shouldIncludeStage(stageDef, layoutCombined)).map((stageDef) => {
    const manual = manualStages[stageDef.id] || { bspAmount: "", plcAmount: "" };

    if (stageDef.isToken) {
      const fromManual = parseManualAmount(manual.bspAmount);
      const bspAmount = fromManual > 0 ? fromManual : resolveTokenAmount(bsp, tokenAmount);
      return {
        id: stageDef.id,
        label: stageDef.label,
        bspPercent: bsp > 0 ? bspAmount / bsp : 0,
        plcPercent: 0,
        bspAmount,
        plcAmount: 0,
        totalAmount: bspAmount,
        isToken: true,
      };
    }

    const bspAmount = parseManualAmount(manual.bspAmount);
    const plcAmount = plcPending ? 0 : parseManualAmount(manual.plcAmount);

    return {
      id: stageDef.id,
      label: stageDef.label,
      bspPercent: bsp > 0 ? bspAmount / bsp : 0,
      plcPercent: plcTotal > 0 ? plcAmount / plcTotal : 0,
      bspAmount,
      plcAmount,
      totalAmount: bspAmount + plcAmount,
      isToken: false,
    };
  });
}

export function resolvePaymentPlan(form, bsp, plcAmount) {
  const layoutCombined = Boolean(form.layoutCombined);
  if (form.manualPricing) {
    return buildPaymentPlanFromManual({
      manualBsp: form.manualBsp,
      manualPlcAmount: form.manualPlcAmount,
      manualStages: form.manualStages,
      tokenAmount: form.tokenAmount,
      layoutCombined,
      plcPending: Boolean(form.plcPending),
    });
  }
  return buildPaymentPlan(bsp, plcAmount, form.tokenAmount, layoutCombined);
}

export function sumPaymentPlan(field, paymentPlan = []) {
  return paymentPlan.reduce((total, stage) => total + (stage[field] || 0), 0);
}

export function formatStageBspPercentLabel(stage, { tokenLabel = "—" } = {}) {
  if (stage.isToken) return tokenLabel;
  const bspPart = `${(stage.bspPercent * 100).toFixed(1).replace(/\.0$/, "")}%`;
  if (stage.plcPercent > 0) {
    const plcPart = `${Math.round(stage.plcPercent * 100)}% PLC`;
    return `${bspPart} + ${plcPart}`;
  }
  return bspPart;
}

export function formatPlcLabels(plc, noPlc, plcPending = false, customPlc = null) {
  if (plcPending) return PLC_PENDING_LABEL;
  if (noPlc && !customPlc?.enabled) return "No PLC";
  const selected = PLC_OPTIONS.filter((opt) => plc[opt.id]).map((opt) => opt.label);
  const parts = [...selected];
  if (customPlc?.enabled) {
    if (customPlc.mode === "amount" && customPlc.amount) {
      parts.push(`Custom PLC (Rs. ${customPlc.amount})`);
    } else if (customPlc.percent) {
      parts.push(`Custom PLC (${customPlc.percent}% of BSP)`);
    } else {
      parts.push("Custom PLC");
    }
  }
  return parts.length ? parts.join(", ") : "No PLC";
}

export function formatPlotNumber(plotNumber, plotPending = false) {
  if (plotPending) return PLOT_PENDING_LABEL;
  return plotNumber || "—";
}

export function getApplicantBlocks(customer) {
  const primary = {
    title: customer.jointDeal ? "Applicant 1" : "Applicant",
    name: customer.name,
    userId: customer.userId,
    email: customer.email,
    address: customer.address,
    mobile: customer.mobile,
    aadhaar: customer.aadhaar,
    pan: customer.pan,
  };

  if (!customer.jointDeal) return [primary];

  const second = customer.applicant2 || {};
  return [
    primary,
    {
      title: "Applicant 2",
      name: second.name,
      userId: "",
      email: second.email,
      address: second.address,
      mobile: second.mobile,
      aadhaar: second.aadhaar,
      pan: second.pan,
    },
  ];
}

export function customerToForm(customer) {
  const tokenStage = customer.paymentPlan?.find((stage) => stage.id === "token");
  const tokenAmt = customer.tokenAmount != null
    ? String(customer.tokenAmount)
    : tokenStage?.bspAmount != null
      ? String(tokenStage.bspAmount)
      : "";

  return {
    name: customer.name || "",
    userId: customer.userId || "",
    email: customer.email || "",
    address: customer.address || "",
    mobile: customer.mobile || "",
    aadhaar: customer.aadhaar || "",
    pan: customer.pan || "",
    jointDeal: Boolean(customer.jointDeal),
    applicant2: { ...EMPTY_APPLICANT, ...(customer.applicant2 || {}) },
    plotNumber: customer.plotPending ? "" : (customer.plotNumber || ""),
    plotPending: Boolean(customer.plotPending),
    inventoryCount: String(normalizeInventoryCount(customer.inventoryCount, customer.inventoryType)),
    category: customer.category || "Residential",
    sizeSqYds: customer.sizeSqYds != null ? String(customer.sizeSqYds) : "",
    sizeRemarks: customer.sizeRemarks ?? "",
    basicRatePerSqYd: customer.basicRatePerSqYd != null ? String(customer.basicRatePerSqYd) : "",
    noPlc: Boolean(customer.noPlc),
    plcPending: Boolean(customer.plcPending),
    plc: { corner: false, green: false, wideRoad: false, ...(customer.plc || {}) },
    customPlc: {
      enabled: Boolean(customer.customPlc?.enabled),
      mode: customer.customPlc?.mode === "amount" ? "amount" : "percent",
      percent: customer.customPlc?.percent != null ? String(customer.customPlc.percent) : "",
      amount: customer.customPlc?.amount != null ? String(customer.customPlc.amount) : "",
    },
    tokenAmount: tokenAmt,
    layoutCombined: Boolean(customer.layoutCombined),
    manualPricing: Boolean(customer.manualPricing),
    manualBsp: customer.manualPricing && customer.bsp != null ? String(customer.bsp) : "",
    manualPlcAmount:
      customer.manualPricing && !customer.plcPending && customer.plcAmount != null
        ? String(customer.plcAmount)
        : "",
    manualStages: customer.manualPricing
      ? manualStagesFromPaymentPlan(customer.paymentPlan)
      : {},
  };
}

export function buildCustomerRecord(form, existing = {}) {
  const manualPricing = Boolean(form.manualPricing);
  const plcPending = Boolean(form.plcPending);
  const layoutCombined = Boolean(form.layoutCombined);
  const paidAmount = existing.paidAmount || 0;
  const customPlc = form.customPlc || EMPTY_CUSTOMER_FORM.customPlc;

  let bsp;
  let plcAmount;
  let paymentPlan;
  let tokenAmount;

  if (manualPricing) {
    bsp = parseManualAmount(form.manualBsp);
    plcAmount = plcPending ? 0 : parseManualAmount(form.manualPlcAmount);
    paymentPlan = buildPaymentPlanFromManual({
      manualBsp: form.manualBsp,
      manualPlcAmount: form.manualPlcAmount,
      manualStages: form.manualStages,
      tokenAmount: form.tokenAmount,
      layoutCombined,
      plcPending,
    });
    const tokenStage = paymentPlan.find((stage) => stage.id === "token");
    tokenAmount = tokenStage?.bspAmount ?? resolveTokenAmount(bsp, form.tokenAmount);
  } else {
    bsp = calculateBsp(form.sizeSqYds, form.basicRatePerSqYd);
    plcAmount = calculatePlcAmount(bsp, form.plc, Boolean(form.noPlc) && !plcPending, plcPending, customPlc);
    tokenAmount = resolveTokenAmount(bsp, form.tokenAmount);
    paymentPlan = buildPaymentPlan(bsp, plcAmount, tokenAmount, layoutCombined);
  }

  const noPlc = Boolean(form.noPlc) && !plcPending;
  const totalAmount = bsp + plcAmount;
  const trimmedSizeRemarks = (form.sizeRemarks || "").trim();

  const record = {
    ...existing,
    customerId: existing.customerId || `SOE-${Math.floor(1000 + Math.random() * 9000)}`,
    accessToken: existing.accessToken || "",
    name: form.name.trim(),
    userId: (form.userId || "").trim(),
    email: (form.email || "").trim().toLowerCase(),
    address: form.address.trim(),
    mobile: form.mobile.trim(),
    aadhaar: form.aadhaar.trim(),
    pan: form.pan.trim(),
    jointDeal: Boolean(form.jointDeal),
    applicant2: form.jointDeal
      ? {
          name: (form.applicant2?.name || "").trim(),
          email: (form.applicant2?.email || "").trim().toLowerCase(),
          address: (form.applicant2?.address || "").trim(),
          mobile: (form.applicant2?.mobile || "").trim(),
          aadhaar: (form.applicant2?.aadhaar || "").trim(),
          pan: (form.applicant2?.pan || "").trim(),
        }
      : { ...EMPTY_APPLICANT },
    plotNumber: form.plotPending ? "" : form.plotNumber.trim(),
    plotPending: Boolean(form.plotPending),
    inventoryCount: normalizeInventoryCount(form.inventoryCount, form.inventoryType),
    inventoryType: formatInventoryType(form.inventoryCount),
    category: form.category,
    sizeSqYds: Number(form.sizeSqYds),
    basicRatePerSqYd: Number(form.basicRatePerSqYd),
    noPlc,
    plcPending,
    plc: { ...form.plc },
    customPlc: {
      enabled: Boolean(customPlc.enabled),
      mode: customPlc.mode === "amount" ? "amount" : "percent",
      percent: customPlc.percent ? Number(customPlc.percent) : null,
      amount: customPlc.amount ? Number(customPlc.amount) : null,
    },
    manualPricing,
    plcAmount,
    bsp,
    totalAmount,
    paidAmount,
    pendingAmount: totalAmount - paidAmount,
    paymentPlan,
    tokenAmount,
    layoutCombined,
    payments: existing.payments || [],
    lastUpdatedAt: new Date().toISOString(),
    createdAt: existing.createdAt || new Date().toISOString(),
  };

  if (trimmedSizeRemarks) {
    record.sizeRemarks = trimmedSizeRemarks;
  } else {
    delete record.sizeRemarks;
  }

  return record;
}

export const SAMPLE_CUSTOMERS = [
  buildCustomerRecord(
    {
      name: "Amanpreet Singh",
      userId: "USR-1001",
      email: "amanpreet.demo@gmail.com",
      address: "House No. 42, Model Town, Patiala, Punjab – 147001",
      mobile: "9876543210",
      aadhaar: "XXXX-XXXX-4521",
      pan: "ABCDE1234F",
      jointDeal: false,
      applicant2: { ...EMPTY_APPLICANT },
      plotNumber: "P-21",
      plotPending: false,
      inventoryCount: "1",
      category: "Residential",
      sizeSqYds: "200",
      basicRatePerSqYd: "12500",
      plc: { corner: true, green: false, wideRoad: true },
      noPlc: false,
      plcPending: false,
      customPlc: { enabled: false, mode: "percent", percent: "", amount: "" },
      tokenAmount: "625000",
      layoutCombined: false,
    },
    {
      customerId: "SOE-1023",
      accessToken: "demo",
      paidAmount: 1500000,
      payments: [
        { date: "2026-05-01", amount: 500000, chequeRtgs: "CHQ-88421", bank: "HDFC Bank" },
        { date: "2026-05-12", amount: 1000000, chequeRtgs: "RTGS-992104", bank: "ICICI Bank" },
      ],
    }
  ),
];
